import { DateEffectMenuItem } from './effects/date/date-effect-menu-item';
import { DeadlineEffectMenuItem } from './effects/deadline/deadline-effect-menu-item';
import { LastTimeEffectMenuItem } from './effects/last-time/last-time-effect-menu-item';
import { ProgressEffectMenuItem } from './effects/progress/progress-effect-menu-item';
import { SnoozeEffectMenuItem } from './effects/snooze/snooze-effect-menu-item';
import { TodayEffectMenuItem } from './effects/today/today-effect-menu-item';

export function EffectMenuItems({ nodeId }: { nodeId: string }) {
  return (
    <>
      <TodayEffectMenuItem nodeId={nodeId} />
      <SnoozeEffectMenuItem nodeId={nodeId} />
      <DateEffectMenuItem nodeId={nodeId} />
      <DeadlineEffectMenuItem nodeId={nodeId} />
      <LastTimeEffectMenuItem nodeId={nodeId} />
      <ProgressEffectMenuItem nodeId={nodeId} />
      {/* <EffectMenuItem icon={MonoIcon.cake} iconColor={'#FFCE1B'} title={'Set Reward'} subtitle={'Go gym, and treat myself to a bubble tea'} />
      <EffectMenuItem icon={MonoIcon.cash} iconColor={'#0BDA51'} title={'Set Value'} subtitle={'After refinancing, expect to save 1K'} /> */}
    </>
  );
}
